import ssctBnbCakeLpFarmingPool65 from "../abis/development/ssctBnb/pools/65";

const host = "https://bscscan.com/address";
const swapHost = "https://pancakeswap.finance/add";
const pairHost = "https://pancakeswap.info/pool";

export default [
  {
    title: "SAUNA-BNB Cake LP Farming",
    temperature: 65,
    type: "bnb",
    contractAddress: "0x578ab8311dbcf2a5a4b80ca5384a9447d058633a",
    minApr: 159,
    abi: ssctBnbCakeLpFarmingPool65.abi,
    url: `${host}/0x578ab8311dbcf2a5a4b80ca5384a9447d058633a`,
    swapUrl: `${swapHost}/BNB/0x06b889a7a7fa15D8cC7CFf147962C4232cCE7CF0`,
    pairUrl: `${pairHost}/0x555808d7e7b82b9beef6388b65e1d98cf6069f75`,
  },
];
